/* global appData */
import { mapState } from 'vuex';

// Components
import VRuntimeTemplate from "v-runtime-template";
import tooltip from '../tooltip/tooltip.js';
import QdTabs from '../tabs/tabs.js';
import QdTabsContent from '../tabs-content/tabs-content.js';
import QdTabContent from '../tab-content/tab-content.js';
import QdInlineYoutubeVideo from '../inline-youtube-video/inline-youtube-video.js'
import Accordion from '../accordion/accordion.js';

// Mixins
//import { PersonalizeContent } from '../../mixins/personalize-content.js';

// Template and media files
import template from './content.vhtml';
import quoteIcon from '../../../_img/icons/icon-quote.svg';


export default {
	name: 'qdContent',
	template: template,
	components: {
		VRuntimeTemplate,
		tooltip,
		QdTabsContent,
		QdTabContent,
		QdTabs,
		QdInlineYoutubeVideo,
		quoteIcon,
		Accordion,
	},
	mixins: [
		//PersonalizeContent,
	],
	props: {
		heading: {
			type: String,
			default: '',
		},
		manchet: {
			type: String,
			default: '',
		},
		content: {
			type: Array,
			default: null,
		}
	},
	data() {
		return {
			selectedTab: 0,
		}
	},
	computed: {
		headingClasses: vm => ['o-heading o-heading--dot', {
			'o-heading--transparent-right': !vm.showHeading,
		}],
		manchetClasses: vm => ['o-manchet', {
			'o-manchet--transparent-right': !vm.showManchet,
		}],
		contentClasses: vm => ['article-content__content', {
			'article-content__content--transparent-right': !vm.showContent,
		}],
		...mapState({
			showHeading: state => state.content.showHeading,
			showManchet: state => state.content.showManchet,
			showContent: state => state.content.showContent,
		}),
	},
	methods: {
		changeTab(index) {
			this.selectedTab = index;
		}
	}
};



// WEBPACK FOOTER //
// ./assets/_js/components/content/content.js